@import "../../foundation/styles/codePalette.css";

.csv {
  background: transparent;
}

.col0 {
  color: var(--code-base09);
}

.col1 {
  color: var(--code-base0b);
}

.col2 {
  color: var(--code-base0f);
}

.col3 {
  color: var(--code-base0e);
}

.col4 {
  color: var(--code-base0a);
}

.col5 {
  color: var(--code-base0c);
}
